
import { Component, Mixins, Watch } from 'vue-property-decorator';
import LayoutDefault from '@/layouts/LayoutDefault.vue';
import LayoutPublic from '@/layouts/LayoutPublic.vue';
import ContentBlocks from '@/components/content/ContentBlocks.vue';
import Hero from '@/components/Hero.vue';
import CmsContentMixin from '@/mixins/CmsContentMixin';

@Component({
  components: { LayoutDefault, LayoutPublic, ContentBlocks, Hero },
})
export default class ContentPage extends Mixins(CmsContentMixin) {
  pageName = '';

  hasBackgroundColor = false;

  get layout(): string {
    return this.$store.getters['auth/signedIn']
      ? 'LayoutDefault'
      : 'LayoutPublic';
  }

  async created() {
    this.isLoading = true;
    try {
      await this.fetchContent();
      this.isLoading = false;
    } catch (e) {
      await this.$router.replace({ name: '404' });
    } finally {
      this.isLoading = false;
    }
  }

  @Watch('$route', { immediate: true })
  onUrlChange(route: any) {
    if (route.name === 'eat-this') {
      this.pageName = 'eat-this';
      this.hasBackgroundColor = true;
    } else {
      this.pageName = '';
      this.hasBackgroundColor = false;
    }

    this.fetchContent();
  }
}
